import React from 'react';

import ProfileShow from 'components/user/profile/show';
import ProfileSecurity from 'components/user/profile/security';
import ProfileSessionInfo from 'components/user/profile/session_info';
import BreadcrumbContainer from 'components/layout/breadcrumb_container';
import Container from 'components/layout/container';
import TabsContainer from 'components/layout/tabs_container';
import TopMenu from 'components/layout/top_menu';
import { FormattedMessage } from 'react-intl';
import { BreadCrumbTypography } from 'components/styles_components/typography';

const Profile = () => {
  return (
    <>
      <TopMenu>
        <BreadcrumbContainer>
          <BreadCrumbTypography>
            <FormattedMessage id="breadcrumb.usersprofile" />
          </BreadCrumbTypography>
        </BreadcrumbContainer>
      </TopMenu>
      <Container>
        <TabsContainer
          tabs={[
            { key: 'data', label: <FormattedMessage id="user.profile.data" />, visible: true },
            { key: 'security', label: <FormattedMessage id="user.profile.security" />, visible: true },
            { key: 'sessions', label: <FormattedMessage id="user.profile.sessions" />, visible: true },
          ]}
          content={[
            <ProfileShow key="profile-show-content" />,
            <ProfileSecurity key="profile-security-content" />,
            <ProfileSessionInfo key="profile-session-info-content" />,
          ].filter((item) => item !== false)}
        />
      </Container>
    </>
  );
};

export default Profile;
